// extracted by mini-css-extract-plugin
export var checkbox = "_2p-0";
export var circle = "_2p-3";
export var horizontalContainer = "_2p-7";
export var sm = "_2p-5";
export var switch0 = "_2p-2";
export var switchDisabled = "_2p-8";
export var switchEnabled = "_2p-1";
export var textSwitchContainer = "_2p-9";
export var textSwitchOption = "_2p-a";
export var textSwitchOptionSelected = "_2p-b";
export var verticalContainer = "_2p-6";
export var xs = "_2p-4";